export default __webpack_public_path__ + "static/media/base-report16.82976230.png";